import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {  useNavigate } from "react-router-dom";

import logo from "../../images/logo-full.png";
import bgimage from "../../images/login-img/pic-5.jpg";
import { authenticate, signout } from "../../feature/authSlice";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PasswordField from "../../jsx/components/fields/passwordField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import { requestForToken } from "../../firebase";
import "./auth.scss";
import {
  confirmPasswordValidation,
  emailValidation,
  noSpaceOnChange,
  passwordValidation,
  phoneValidation,
} from "../../validations/validation";
import { setUserDetails } from "../../feature/userData/userData";
import { checkCredentials } from "../../service/api/user/login";
import InputField from "../../jsx/components/fields/inputField";
import { resetPassword } from '../../service/api/user/resetPassword'
import { userDetailsByToken } from '../../service/api/user/userTokenDetails'

export default function CreatePassword(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')

  const [isNewPassword, setIsNewPassword] = useState(false)
  const [isConfirmPassword, setIsConfirmPassword] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  


  const [loading, setLoading] = useState(false)
  const [securityCode,setSecurityCode] = useState('')
  const [email,setEmail] = useState('')
  const [phoneCode,setPhoneCode] = useState(null)
  const [phoneNumber,setPhoneNumber] = useState(null)


  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    if (passwordValidation(newPassword)) {
        if (confirmPasswordValidation(newPassword, confirmPassword)) {
          let details = {
            phone_code_id_int: parseInt(phoneCode),
            phone_number_int: parseInt(phoneNumber),
            email_chr: email || "",
            new_password: newPassword,
            confirm_password: confirmPassword,
            security_code_chr: securityCode,
          }
          dispatch(
            resetPassword(
              details,
              (res) => {
                navigate('/')
                // openNotification('success', 'topRight', res.data.message)
              },
              (error) => {
                setLoading(false)
                // openNotification('failed', 'topRight', error.data.message)
              },
            ),
          )
        } else {
          setIsConfirmPassword(true)
        }
      } else {
        setIsNewPassword(true)
      }
  }

  const handleNewPassword = (e) => {
    setIsNewPassword(false)
    setNewPassword(e.target.value)
  }
  const handleConfirmPassword = (e) => {
    setIsConfirmPassword(false)
    setConfirmPassword(e.target.value)
  }

  function handleNewPasswordBlur (){
    if (!passwordValidation(newPassword)) {

      setIsNewPassword(true)
    }
  }



  function handleConfirmPasswordBlur (){
    if (!confirmPasswordValidation(newPassword, confirmPassword)){
      setIsConfirmPassword(true)
    }
  }
  function handleMoveToSignUp() {
    navigate("/signup", { replace: true });
  }

  
useEffect(()=>{
  dispatch(signout())
    localStorage.clear()
   
    
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const tokenId = urlParams.get('tokenId')
  
    var details = {
      token_id : tokenId
    }
    dispatch(userDetailsByToken(details,(res)=>{
   
    setSecurityCode(res.data.data.security_code_chr)
    setEmail(res.data.data.email_chr)
    setPhoneNumber(res.data.data.phone_number_int)
    setPhoneCode(res.data.data.phone_code_id_int)
  
    },()=>{}))
  },[])

  return (
    <div className="">
      <div className="row  align-items-center justify-contain-center bg-login">
        <div className="col-xl-12 ">
          <div className="card border-0">
            <div className="card-body login-bx">
              <div className="row " style={{height:'100vh'}}>
                <div className="col-xl-7 col-md-6  text-center">
                  <img src={outerPhoto} alt="" style={{ maxWidth: "100%" }} />
                </div>
                <div
                  className="col-xl-4 col-md-6 pe-0 d-flex"
                  style={{ alignItems: "center",justifyContent:'center' }}>
                  <div className="sign-in-your">
                    <div>
                      <p
                        className="login-title"
                        style={{ fontSize: "21px", fontWeight: "600" }}>
                       Create Password
                      </p>
                    </div>

                    <form onSubmit={handleSubmit} >

                      <PasswordField
                        onChange={handleNewPassword}
                        inputValue={newPassword}
                        errorOccured={isNewPassword}
                        errorMessage={"invalid password"}
                        labelName={"Password"}
                        handleOnBlur={handleNewPasswordBlur}
                      />
                        <PasswordField
                        onChange={handleConfirmPassword}
                        inputValue={confirmPassword}
                        errorOccured={isConfirmPassword}
                        errorMessage={"Password doesnot match"}
                        labelName={"Confirm Password"}
                        handleOnBlur={handleConfirmPasswordBlur}
                      />
                
                  
                    

                      <div>
                        <p>
                          Do not have account yet?{" "}
                          <span
                            className="waiting-txt"
                            onClick={handleMoveToSignUp}>
                           Register here
                          </span>
                        </p>
                      </div>
                      <PrimaryButton
                        buttonName={"Submit"}
                        type={"submit"}
                        isLoading={loading}
                        loadingMessage={"Loading..."}
                        style={{width:'100%'}}
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
